import Reveal from "./Reveal";
import { SITE } from "../config/site";

const CHAPTERS = [
  {
    n: "01",
    title: "Every space, treated like our own",
    body: "We don't rush through a checklist and leave. We clean the way we'd want our own homes cleaned — carefully, consistently, and with pride in the details.",
  },
  {
    n: "02",
    title: "A small local team, not a call centre",
    body: "We're not juggling hundreds of accounts. We know our clients by name and remember the details that matter to you — visit after visit. As proud Memorial University (MUN) graduates, we love supporting our community right here in Newfoundland.",
  },
  {
    n: "03",
    title: "Over a decade of hands-on experience",
    body: "Cleaning homes and spaces since 2013 — two years of residential cleaning in Saskatchewan, and continuing work in St. John's from 2015 onward.",
  },
];

export default function Manifesto() {
  return (
    <section id="why-us" data-testid="manifesto-section" className="bg-white py-24 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <Reveal>
          <p className="eyebrow">Why {SITE.shortName}</p>
          <h2 className="mt-4 max-w-3xl font-serif text-4xl tracking-tight text-ink sm:text-5xl lg:text-6xl">
            Reliable, detail-oriented cleaning — <span className="italic text-ocean">never a rushed clean</span>
          </h2>
        </Reveal>

        <div className="mt-20 space-y-0">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.n}
              i={i}
              data-testid={`manifesto-chapter-${c.n}`}
              className="grid gap-6 border-t border-ink/10 py-12 md:grid-cols-[120px_1fr_2fr] lg:gap-12 lg:py-16"
            >
              <span className="font-serif text-6xl italic leading-none text-seafoam lg:text-7xl">{c.n}</span>
              <h3 className="font-serif text-2xl leading-snug tracking-tight text-ink md:text-3xl">{c.title}</h3>
              <p className="max-w-xl text-base leading-relaxed text-slateblue">{c.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal i={3} className="flex flex-wrap gap-x-10 gap-y-3 border-t border-ink/10 pt-10">
          {["Insured", "Bonded", "Locally owned", "Satisfaction guaranteed", "Competitive pricing"].map((t) => (
            <span key={t} className="text-sm font-semibold uppercase tracking-[0.25em] text-ocean">
              {t}
            </span>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
